import { Component } from '@angular/core';

@Component({
    selector: 'app-carf',
    templateUrl: './carf.component.html',
    styleUrls: ['./carf.component.scss'],
    standalone: false
})
export class CARFComponent {

   public selectedSubcategories : number[] =[]
 
}
